<template>
  <main class="evaluationPg mt-[60px]">
    <div class="container">
      <div class="heading">
        <h4 class="mb-0 blackText fw-bold pt-4 mb-4">
          <b>Evaluation </b> - Job ID <span class="orangeText">8448</span>
        </h4>
      </div>
      <div class="breadcrumbs border rounded p-2 mb-4">
        <ul class="d-flex list-inline mb-0">
          <li><a class="greyText">My Account</a></li>
          <li>
            <a class="greyText">Service & Repair History</a>
          </li>
          <li>
            <a
              :href="'/job/detail/'+jobId"
              class="greyText"
            >Job Detail</a>
          </li>
          <li class="blueText">
            Evaluation - Job ID 8448
          </li>
        </ul>
      </div>
      <div class="evaluationSec">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Located at</label>
              <FxSelect v-model="form.locatedAt" :options="optionsFor('House')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Manufacturer</label>
              <FxSelect v-model="form.manufacturer" :options="optionsFor('AIRE-FLO')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Heat</label>
              <FxSelect v-model="form.heat" :options="optionsFor('Strip')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Outer Placement</label>
              <FxSelect v-model="form.outerPlacement" :options="optionsFor('Ground')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Air Handler Location</label>
              <FxSelect v-model="form.airHandlerLocation" :options="optionsFor('Attic')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Manufacture Date</label>
              <input
                type="date"
                class="form-control"
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Capacity AC (tons)</label>
              <FxSelect v-model="form.capacity" :options="optionsFor('1.5 tons')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <h6 class="mb-1">
                Is the system sized properly?
              </h6>
              <div class="radioCheck d-flex mt-3">
                <div class="form-check p-0 me-3">
                  <input
                    id="yes"
                    type="radio"
                    name="radio-group"
                    checked
                  >
                  <label for="yes">Yes</label>
                </div>
                <div class="form-check p-0">
                  <input
                    id="no"
                    type="radio"
                    name="radio-group"
                  >
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">SEER Rating</label>
              <FxSelect v-model="form.seer" :options="optionsFor('14.00')" />
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="mb-1">Refrigerant Type</label>
              <FxSelect v-model="form.refrigerant" :options="optionsFor('cfc')" />
            </div>
          </div>
          <div class="col-lg-6 col-md-4 col-sm-12 col-12">
            <div class="form-group mb-3">
              <h6 class="mb-1">
                Is there advanced air filtration installed on this unit?
              </h6>
              <div class="radioCheck d-flex mt-3">
                <div class="form-check p-0 me-3">
                  <input
                    id="yes"
                    type="radio"
                    name="radio-group"
                    checked
                  >
                  <label for="yes">Yes</label>
                </div>
                <div class="form-check p-0">
                  <input
                    id="no"
                    type="radio"
                    name="radio-group"
                  >
                  <label for="no">No</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="from-group">
              <label
                class="orangeText"
                for="notes "
              >Notes</label>
              <textarea
                name="notes"
                rows="5"
                placeholder="Enter notes here"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <button class="btn buttonPrimary mt-5 mx-auto d-table rounded">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import FxSelect from "@/components/partialComponent/FxSelect.vue";

// static mock screen: each select showed its first option (value = its text) and "One" (value "1")
export default {
  components: {
    FxSelect,
  },
  data() {
    return {
      form: {
        locatedAt: "House",
        manufacturer: "AIRE-FLO",
        heat: "Strip",
        outerPlacement: "Ground",
        airHandlerLocation: "Attic",
        capacity: "1.5 tons",
        seer: "14.00",
        refrigerant: "cfc",
      },
    };
  },
  methods: {
    optionsFor(first) {
      return [{ label: first, value: first }, { label: "One", value: "1" }];
    },
  },
};
</script>
